import { Injectable } from '@angular/core';
import { PortalSettingsService } from './portal-settings.service';

@Injectable({
  providedIn: 'root',
})
export class TimeParserService {
  portalSettings: any;
  time24HourMode: boolean;

  constructor(portalSettingsService: PortalSettingsService) {
    portalSettingsService.portalSettings$.subscribe(latestSettings => {
      this.portalSettings = latestSettings;
    });
    this.time24HourMode = this.portalSettings.Timecard24Hours.ConfigValue == '1';
  }

  parseTime(str: any) {
    let DateJs = <any>Date;
    try {
      if (str == '' || str == null) return null;
      // Handle 3-digit input like '111' (assume it as '1:11')
      if (/^\d{3}$/.test(str)) {
        str = `${str[0]}:${str.substring(1)}`;
      }
      return (
        DateJs.parseExact(str, 'HH') ||
        DateJs.parseExact(str, 'H') ||
        DateJs.parseExact(str, 'hh:mm tt') ||
        DateJs.parseExact(str, 'h:mm tt') ||
        DateJs.parseExact(str, 'h:mmtt') ||
        DateJs.parseExact(str, 'h:mm') ||
        DateJs.parseExact(str, 'hh:mm') ||
        DateJs.parseExact(str, 'h tt') ||
        DateJs.parseExact(str, 'htt') ||
        DateJs.parseExact(str, 'h') ||
        DateJs.parseExact(str, 'HH:mm') ||
        DateJs.parseExact(str, 'hmm') ||
        DateJs.parseExact(str, 'hhmm') ||
        DateJs.parseExact(str, 'h mm') ||
        DateJs.parseExact(str, 'hh mm') ||
        DateJs.parseExact(str, 'hhmmtt') ||
        DateJs.parseExact(str, 'hhmm tt') ||
        DateJs.parseExact(str, 'hmmtt') ||
        DateJs.parseExact(str, 'hmm tt')
      );
    } catch (e) {
      return null;
    }
  }

  parseStartStop(value: any, mode: string, strict = false) {
    if (value != null && value != '') {
      if (value.length > 8) {
        value = value.substr(value.lastIndexOf(' ') + 1);
      }
      let timeStr = value;
      timeStr = timeStr.trim().replace(' ', '');
      const timeOfDay = timeStr.toUpperCase().indexOf('A') != -1 ? 'AM' : timeStr.toUpperCase().indexOf('P') != -1 ? 'PM' : null;
      //detect non-colon time
      if (timeOfDay == null && timeStr.trim().length > 2 && timeStr.indexOf(':') == -1) {
        timeStr = timeStr.slice(0, timeStr.length - 2) + ':' + timeStr.slice(timeStr.length - 2);
      } else if (timeStr.length > 4 && timeStr.indexOf(':') == -1) {
        let tempTimeStr = timeStr.toLowerCase();
        tempTimeStr = tempTimeStr.replace(' ', '').replace('am', '').replace('pm', '').trim();
        tempTimeStr = tempTimeStr.slice(0, tempTimeStr.length - 2) + ':' + tempTimeStr.slice(tempTimeStr.length - 2);
        timeStr = tempTimeStr + ' ' + timeOfDay;
      }
      const timeObj = this.parseTime(timeStr);
      const isValid = timeStr != '' && timeObj != null;
      if (isValid) {
        //Adjust time of new entries based on if the entry was Start or Stop
        if (timeOfDay == null && !this.time24HourMode) {
          if (mode == 'StartTime') {
            //hours format
            if (timeStr >= 1 && timeStr <= 5) {
              timeObj.addHours(12);
            }
            //colon format
            const tempTimeStr = timeStr.replace(':', '');
            if (tempTimeStr >= 100 && tempTimeStr <= 559) {
              timeObj.addHours(12);
            }
          } else if (mode == 'StopTime') {
            //hours format
            if (timeStr >= 1 && timeStr <= 8) {
              timeObj.addHours(12);
            }
            //colon format
            const tempTimeStr = timeStr.replace(':', '');
            if (tempTimeStr >= 100 && tempTimeStr <= 859) {
              timeObj.addHours(12);
            }
          }
        }
        let newTimeStr;
        if (this.time24HourMode) newTimeStr = timeObj.toString('HH:mm');
        else newTimeStr = timeObj.toString('hh:mm tt');
        if (timeStr != newTimeStr) {
          return newTimeStr;
        }
      } else if (strict) return 'Invalid Time';

      return timeStr;
    }
    return '';
  }

  convertTimeString(timeStr) {
    let hours = parseInt(timeStr.substr(0, timeStr.indexOf(':')));
    const minutes = parseInt(timeStr.substr(timeStr.indexOf(':') + 1, 2));
    if (timeStr.indexOf('PM') > -1) {
      //do not add 12 to noon
      if (hours != 12) hours += 12;
    } else {
      //handle midnight
      if (hours == 12) {
        hours = 0;
      }
    }
    return hours + minutes / 60;
  }
}
